"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _alert_props = require("./alert_props");

var _odAnimate = _interopRequireDefault(require("@tencent/od-animate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Alert =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Alert, _PureComponent);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Alert).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      var onClose = _this.props.onClose;

      _this.setState({
        show: false,
        open: false
      });

      if ((0, _spauiUtils.isFunction)(onClose)) {
        onClose(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (e) {
      var onToggle = _this.props.onToggle;

      _this.setState({
        open: !_this.state.open
      });

      if ((0, _spauiUtils.isFunction)(onToggle)) {
        onToggle(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "genTypeClassName", function (type) {
      var newType = type;

      if (type === 'danger') {
        newType = 'strongwarn';
      } else if (type === 'warning') {
        newType = 'warn';
      }

      return newType;
    });

    _defineProperty(_assertThisInitialized(_this), "genIconClassName", function () {
      var _this$props = _this.props,
          iconClassName = _this$props.iconClassName,
          iconType = _this$props.iconType,
          type = _this$props.type;
      var className = "icon-".concat(_this.genTypeClassName(type));

      if (iconType) {
        className = "icon-".concat(_this.genTypeClassName(iconType));
      } else if (iconClassName) {
        className = iconClassName;
      }

      return className;
    });

    _this.state = {
      show: true,
      aniClassName: ''
    };
    return _this;
  }

  _createClass(Alert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    } // 关闭提示

  }, {
    key: "getRect",
    // 获取内容结构的react信息
    value: function getRect() {
      var result = {
        height: 0
      };

      if (this.childrenRef) {
        result = this.childrenRef.getBoundingClientRect();
      }

      return result;
    } // 初始化展开状态

  }, {
    key: "init",
    value: function init() {
      var closable = this.props.closable;

      if (closable && this.childrenRef) {
        if (this.childrenRef.style) {
          this.childrenRef.style.setProperty('--alert-height', "".concat(this.getRect().height, "px"));
        }
      }
    } // 兼容旧的 type

  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          type = _this$props2.type,
          message = _this$props2.message,
          title = _this$props2.title,
          desc = _this$props2.desc,
          description = _this$props2.description,
          showIcon = _this$props2.showIcon,
          icon = _this$props2.icon,
          closable = _this$props2.closable,
          hideBg = _this$props2.hideBg,
          children = _this$props2.children,
          transitionName = _this$props2.transitionName,
          expandContent = _this$props2.expandContent,
          size = _this$props2.size,
          propsShow = _this$props2.show,
          prefix = _this$props2.prefix,
          suffix = _this$props2.suffix,
          _this$props2$contentP = _this$props2.contentProps,
          contentProps = _this$props2$contentP === void 0 ? {} : _this$props2$contentP,
          _this$props2$closeBut = _this$props2.closeButtonProps,
          closeButtonProps = _this$props2$closeBut === void 0 ? {} : _this$props2$closeBut,
          _this$props2$toggleBu = _this$props2.toggleButtonProps,
          toggleButtonProps = _this$props2$toggleBu === void 0 ? {} : _this$props2$toggleBu;
      var _this$state = this.state,
          show = _this$state.show,
          aniClassName = _this$state.aniClassName,
          open = _this$state.open;
      var newType = this.genTypeClassName(type);

      if (!propsShow) {
        return null;
      }

      return _react["default"].createElement(_odAnimate["default"], {
        transitionName: transitionName,
        component: ""
      }, show ? _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-alert', newType, aniClassName, (_classNames = {
          'with-addons': closable,
          'with-desc': desc || description
        }, _defineProperty(_classNames, "spaui-alert-".concat(newType), !hideBg), _defineProperty(_classNames, 'spaui-alert-closable', closable), _defineProperty(_classNames, 'no-icon', !showIcon), _defineProperty(_classNames, 'spaui-alert-expandable', expandContent), _defineProperty(_classNames, 'spaui-alert-expanded', open), _defineProperty(_classNames, 'spaui-alert-folded', !open), _defineProperty(_classNames, size, size), _classNames))
      }, Alert), {
        ref: function ref(el) {
          _this2.childrenRef = el;
        }
      }), prefix, showIcon ? !icon ? _react["default"].createElement("i", {
        className: (0, _classnames["default"])('spaui-alert-icon', this.genIconClassName())
      }) : icon : null, _react["default"].createElement("div", _extends({
        className: "spaui-alert-content"
      }, contentProps), children, title || message ? _react["default"].createElement("div", {
        className: "spaui-alert-title"
      }, title || message) : null, desc || description ? _react["default"].createElement("div", {
        className: "spaui-alert-desc"
      }, desc || description) : null, open ? expandContent : null), expandContent ? _react["default"].createElement("button", _extends({
        type: "button",
        className: "spaui-alert-expand",
        tabIndex: "0"
      }, toggleButtonProps, {
        onClick: this.handleToggle
      }), open ? '收起' : '展开') : null, closable ? _react["default"].createElement("button", _extends({
        type: "button",
        className: "spaui-alert-close",
        tabIndex: "0"
      }, closeButtonProps, {
        onClick: this.handleClose
      }), _react["default"].createElement("i", {
        role: "img",
        "aria-label": "close",
        className: "spaui-icon spaui-icon-remove"
      })) : null, suffix) : null);
    }
  }]);

  return Alert;
}(_react.PureComponent); // 组件标记


_defineProperty(Alert, "propTypes", _alert_props.propTypes);

_defineProperty(Alert, "defaultProps", _alert_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Alert, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Alert;
exports["default"] = _default;